import { useEffect } from "react";
import { isEditableTarget } from "../lib/isEditableTarget";
import { isSyntheticEvent } from "../lib/isSyntheticEvent";
import { navigationShortcuts } from "../lib/navigationShortcuts";
import { navigate } from "../lib/urls";
import { usePersonalWorkEnabled } from "./usePersonalWorkEnabled";

export function useChordShortcuts() {
  const personalWorkEnabled = usePersonalWorkEnabled() === true;
  useEffect(() => {
    let leader: string | null = null;
    let timer: ReturnType<typeof setTimeout> | null = null;

    function reset() {
      leader = null;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function handleKeyDown(e: KeyboardEvent) {
      if (
        isSyntheticEvent(e) ||
        isEditableTarget(e) ||
        e.defaultPrevented ||
        e.isComposing ||
        e.repeat ||
        e.metaKey ||
        e.ctrlKey ||
        e.altKey ||
        e.shiftKey ||
        document.querySelector("dialog[open]") ||
        (e.target instanceof Element &&
          e.target.closest('[role="dialog"], [data-popover]'))
      ) {
        reset();
        return;
      }

      const key = e.key.toLowerCase();

      if (leader) {
        const shortcut = navigationShortcuts.find(
          (shortcut) =>
            shortcut.key === key &&
            (!("personalWork" in shortcut) || personalWorkEnabled)
        );
        reset();
        if (shortcut) {
          e.preventDefault();
          e.stopPropagation();
          navigate(shortcut.route);
        }
        return;
      }

      if (key === "g") {
        leader = key;
        timer = setTimeout(reset, 1500);
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("focusin", reset);
    window.addEventListener("blur", reset);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("focusin", reset);
      window.removeEventListener("blur", reset);
      reset();
    };
  }, [personalWorkEnabled]);
}
